import { service } from "."

export default {
  getAll: () => service.get("/categories/webpublicCat"),
  // getAll: (data) => service.post("/categories/web", data),
}
